<template>
  <div class="taskDetail">
    <van-sticky>
      <van-tabs
        v-model="active"
        @click="onClick"
        swipeable
        title-active-color="#fab13e"
        color="#fab13e"
      >
        <van-tab
          v-for="(item,index) in menu"
          :name="item"
          :key="index"
          :title="item"
        ></van-tab>
      </van-tabs>
    </van-sticky>
    <!-- <div v-if="active=='任务'" class="">
			<myTask :camp_id="camp_id" :user_id="user_id" :type="type"></myTask>
		</div> -->
    <div
      v-if="active=='孩子'"
      class=""
    >
      <myChild
        :camp_id="camp_id"
        :user_id="user_id"
        :type="type"
      ></myChild>
    </div>
    <!-- <div v-else-if="active=='异常'" class="">
			<myReporting :camp_id="camp_id" :user_id="user_id" :type="type"></myReporting>
		</div> -->
  </div>
</template>

<script>
import myTask from '../../publicComponents/myTask'
import myChild from '../../publicComponents/myChild'
import myReporting from '../../publicComponents/myReporting'
export default {
  components: {
    myTask,
    myChild,
    myReporting,
  },
  data() {
    return {
      listChildren: '',
      active: '',
      // menu: ['任务', '孩子', '异常'],
      menu: ['孩子'],
      camp_id: '',
      user_id: '',
      type: '',
    }
  },
  methods: {
    onClick(name) {
      let query =
        'camp_id=' +
        this.camp_id +
        '&user_id=' +
        this.user_id +
        '&type=' +
        this.type +
        '&tab=' +
        name
      this.$router.replace('/subPackages/myTask/taskDetail?' + query)
    },
  },
  created() {
    const that = this
    that.camp_id = this.$route.query.camp_id
    that.user_id = this.$route.query.user_id
    that.type = this.$route.query.type
    if (this.$route.query.tab) {
      that.active = this.$route.query.tab
    } else {
      that.active = '任务'
    }

    // if(that.active=='任务'){
    // 	that.loadTask();
    //  }else if(that.active=='孩子'){
    // 	that.loadComment();
    //  }else if(that.active=='异常'){
    // 	that.loadReport();
    //  }
  },
  activated() {
    const that = this
    that.camp_id = this.$route.query.camp_id
    that.user_id = this.$route.query.user_id
    that.type = this.$route.query.type
    if (this.$route.query.tab) {
      that.active = this.$route.query.tab
    } else {
      that.active = '任务'
    }
  },
}
</script>


